import "./index.css";

const NotFound = () => {
	return (
		<div className="container page-not-found">
			<h2>Page not found</h2>
			<div className="page-not-found-code">- 404 -</div>
		</div>
	);
};

export default NotFound;
